export const ACTION_GET_SETTING = '/PageContent/GetSettings';